import React from "react";
import { Select } from 'antd';
import './index.less';
import yylogo from 'static/img/yylogo.png'
import weixin from 'static/img/weixin.png'
export default function Footer() {
	const selectFn = (value) => {
		window.open(value)
	}
	return (
		<footer className="footerBox">
			<div className="footerBox-top">
				<div className="bottomlogo">
					<img src={yylogo} alt="" />
					<div>升级数字底座、深耕行业、加速交易平台创新</div>
				</div>
				<div className="footerBox-weixin">
					{/* <div>
						<div><img src={weixin} /></div>
						<span>微信小程序</span>
					</div> */}
				</div>
			</div>
			<div className="footerBox-bottom">
			<div>
				<span>友情链接</span>
				<Select onSelect={selectFn}
					defaultValue="---主管部门---"
					style={{ width:240 }}
					options={[
						{ value:'http://www.sdpc.gov.cn', label: '中华人民共和国国家发展和改革委员会' },
						{ value:'http://www.mof.gov.cn/index.htm', label: '中华人民共和国财政部' },
						{ value:'http://www.szjs.gov.cn', label: '深圳市住房和建设局' },
						{ value:'http://www.szfb.gov.cn', label: '深圳市财政委员会', },
						{ value:'http://www.szpb.gov.cn', label: '深圳市发展和改革委员会', },
						{ value:'http://www.szjmxxw.gov.cn', label: '深圳市经济贸易和信息化委员会', },
					]}
				/>
				<Select onSelect={selectFn}
					defaultValue="---相关链接---"
					style={{ width:240 }}
					options={[
						{ value:'http://www.cgzx.sz.gov.cn', label: '中国·深圳政府采购' },
						{ value:'http://www.szjs.gov.cn/jsjy', label: '深圳市建设工程交易中心' },
						{ value:'http://www.ccgp.gov.cn', label: '中国政府采购网' },
						{ value:'http://www.chinabidding.com', label: '中国国际招投标网', },
						{ value:'http://www.chinabidding.com.cn', label: '中国采购与招标网', },
						{ value:'http://www.creditchina.gov.cn', label: '信用中国', },
						{ value:'https://www.szcredit.org.cn/web/index.html', label: '深圳信用网', },
						{ value:'http://www.zfcg.sz.gov.cn', label: '深圳市政府采购监督管理网', },
					]}
				/>
			</div>
			<div>版权所有©深圳市远东数智采技术服务有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022095238号</a></div>
		</div>
	</footer>
	);
}
